<div class="ged-doc">
  <div class="ged-doc__id">
    <span class="ged-doc__tile">
      <pr-icon [name]="identityTile" [width]="22"></pr-icon>
    </span>

    <span class="ged-doc__main">
      <span class="ged-doc__name">
        <span class="ged-doc__name-text">{{ name }}</span>
        @for (tag of tags; track tag.label) {
          <span
            class="ged-doc__chip"
            [class.is-success]="tag.level === 'success'"
            [class.is-danger]="tag.level === 'danger'"
            [class.is-warning]="tag.level === 'warning'"
            >{{ tag.label }}</span
          >
        }
      </span>
      <span class="ged-doc__meta">
        <span class="ged-doc__who">{{ ownersLabel }}</span>
        @if (typeLabel) {
          <span class="ged-doc__sep">·</span>{{ typeLabel }}
        }
        @if (fileCountLabel) {
          <span class="ged-doc__sep">·</span>{{ fileCountLabel }}
        }
        @if (createdDate) {
          <span class="ged-doc__sep">·</span>ajouté le {{ createdDate }}
        }
      </span>
    </span>

    @if (expiryDate) {
      <span class="ged-doc__expiry" [class.is-expired]="expired">
        <span class="ged-doc__expiry-label">Expire le</span>
        <span class="ged-doc__expiry-value">{{ expiryDate }}</span>
      </span>
    }
  </div>

  <div class="ged-doc__bar">
    <pr-button
      display="neutral"
      variant="outline"
      size="lg"
      icon="folder_open"
      label="Choisir un autre document de la GED"
      (onClick)="openGedPicker()"
    ></pr-button>

    <pr-button
      size="lg"
      icon="download"
      [label]="downloading ? 'Téléchargement…' : 'Télécharger'"
      [disabled]="downloading"
      (onClick)="download()"
    ></pr-button>

    <span class="ged-doc__spacer"></span>

    <span class="ged-doc__menu-wrap">
      <button
        type="button"
        class="ged-doc__more"
        aria-haspopup="true"
        [attr.aria-expanded]="menuOpen"
        aria-label="Autres actions"
        (click)="toggleMenu($event)"
      >
        <pr-icon name="more_vert" [width]="20"></pr-icon>
      </button>

      @if (menuOpen) {
        <div
          class="ged-doc__menu"
          role="menu"
          (click)="$event.stopPropagation()"
        >
          <button
            type="button"
            class="ged-doc__menu-item"
            role="menuitem"
            (click)="onWithdraw()"
          >
            <pr-icon name="link_off" [width]="19"></pr-icon>
            <span>
              <b>Retirer de la souscription</b>
              <span>Le document reste dans la GED du client.</span>
            </span>
          </button>

          <span class="ged-doc__menu-sep"></span>

          <button
            type="button"
            class="ged-doc__menu-item is-danger"
            role="menuitem"
            (click)="askDelete()"
          >
            <pr-icon name="delete" [width]="19"></pr-icon>
            <span>
              <b>Supprimer de la GED</b>
              <span
                >Définitif : fichiers effacés et signature électronique
                annulée.</span
              >
            </span>
          </button>
        </div>
      }
    </span>
  </div>
</div>

<pr-button-confirm
  #deleteConfirm
  class="ged-doc__confirm"
  display="danger"
  icon="delete"
  title="Supprimer de la GED"
  comment="Cette suppression est définitive : les fichiers sont effacés et la signature électronique liée est annulée. Pour changer de document sans le détruire, utilisez « Retirer de la souscription »."
  labelConfirm="Supprimer définitivement"
  labelCancel="Annuler"
  (onConfirm)="remove.emit()"
>
</pr-button-confirm>

<ged-picker
  #gedPickerRef
  [accountId]="accountId"
  [documents]="documents"
  [ownerId]="ownerId"
  (select)="onPick($event)"
></ged-picker>
